import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

function Footer() {
  const { t } = useTranslation();

  return (
    <footer className="site-footer">
      <div className="footer-inner">
        <div>
          <div className="footer-brand">BASS</div>
          <p className="footer-tagline">
            {t('footer.tagline')}
          </p>
        </div>
        <div className="footer-col">
          <h4>{t('footer.catalog')}</h4>
          <ul>
            <li><Link to="/categories/microphones">{t('footer.microphones')}</Link></li>
            <li><Link to="/categories/speakers">{t('footer.speakers')}</Link></li>
            <li><Link to="/categories/mixers">{t('footer.mixers')}</Link></li>
            <li><Link to="/categories/amps">{t('footer.amplifiers')}</Link></li>
          </ul>
        </div>
        <div className="footer-col">
          <h4>{t('footer.info')}</h4>
          <ul>
            <li><Link to="/about">{t('footer.about')}</Link></li>
            <li><Link to="/#process">{t('footer.process')}</Link></li>
            <li><Link to="/contact">{t('footer.contact')}</Link></li>
          </ul>
        </div>
        <div className="footer-col">
          <h4>{t('footer.contact')}</h4>
          <ul>
            <li><a href="mailto:mikolaj.bonowski@gmail.com">{t('footer.email')}</a></li>
            <li>
              <a
                href="https://www.linkedin.com/in/miko%C5%82aj-b-59732676/"
                target="_blank"
                rel="noopener noreferrer"
              >
                {t('footer.linkedIn')}
              </a>
            </li>
            <li><span>{t('footer.location')}</span></li>
          </ul>
        </div>
      </div>
      <div className="footer-bottom">
        <span>{t('footer.copyright')}</span>
        <span style={{ fontSize: '1.3rem' }}>🙂</span>
      </div>
    </footer>
  );
}

export default Footer;
